// extracted by mini-css-extract-plugin
module.exports = {"comments":"index_comments__3pVzj","title":"index_title__Zg8v-","desc":"index_desc__3w_6S","content":"index_content__3athf"};